import { motion, Variants } from "motion/react"

const waveGroupVariants: Variants = {
  rest: { scale: 1 },
  hover: {
    scale: [1, 1.3, 1.25],
    transition: { duration: 0.3, ease: "easeOut", times: [0, 0.3, 1] },
  },
}

const wavePathVariants: Variants = {
  rest: { fill: "#607CDE" },
  hover: { fill: "#C62E1D", transition: { duration: 0.3, ease: "easeOut" } },
}

const noteGroupVariants: Variants = {
  rest: { scale: 1, rotate: 0 },
  hover: {
    scale: [1, 1.3, 1.25],
    rotate: [0, -5, -5],
    transition: { duration: 0.3, ease: "easeOut", times: [0, 0.6, 1] },
  },
}

export const DistractionAssessmentAnimation = ({ hover }: { hover?: boolean }) => (
  <motion.div
    initial="rest"
    animate={hover ? "hover" : "rest"}
    className="w-full aspect-[41/28] relative [&_svg]:absolute [&_svg]:w-full [&_svg]:h-auto overflow-hidden"
  >
    <motion.svg
      className="wave"
      variants={waveGroupVariants}
      width="408"
      height="276"
      viewBox="0 0 408 276"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <motion.path
        variants={wavePathVariants}
        d="M100.558 91.2465C101.837 91.9743 102.252 93.5982 101.487 94.8452C93.8466 107.281 89.7029 121.533 89.5322 136.136C89.2947 152.081 93.7851 167.688 102.433 181.104C103.236 182.35 102.829 184.005 101.534 184.743L95.0308 188.453C93.8097 189.149 92.249 188.771 91.4959 187.595C81.9099 172.652 76.8036 155.278 76.7684 137.528C76.6981 120.216 81.4189 103.267 90.4982 88.4486C91.2372 87.2415 92.8208 86.842 94.0578 87.5472L100.558 91.2465Z"
      />
      <motion.path
        variants={wavePathVariants}
        d="M119.835 102.251L126.344 105.947C127.63 106.676 128.051 108.314 127.268 109.557C121.97 117.964 119.204 127.677 119.29 137.615C119.353 147.878 122.468 157.858 128.221 166.349C129.064 167.592 128.661 169.28 127.348 170.029L120.84 173.742C119.64 174.427 118.1 174.077 117.338 172.935C110.209 162.259 106.44 149.686 106.533 136.83C106.602 124.926 109.92 113.358 116.281 103.149C117.027 101.95 118.6 101.549 119.835 102.251Z"
      />
      <motion.path
        variants={wavePathVariants}
        d="M145.646 116.951L152.16 120.656C153.481 121.408 153.875 123.106 153.022 124.357C147.374 132.632 147.805 143.638 154.02 151.449C155.002 152.682 154.625 154.493 153.249 155.277L146.7 159.002C145.542 159.66 144.066 159.36 143.274 158.299C138.694 152.149 136.248 144.696 136.301 137.006C136.343 130.164 138.344 123.525 142.141 117.771C142.899 116.621 144.443 116.267 145.648 116.951L145.646 116.951Z"
      />
    </motion.svg>

    <motion.svg
      className="note"
      variants={noteGroupVariants}
      width="408"
      height="276"
      viewBox="0 0 408 276"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M197.516 130.603C197.398 130.624 196.892 130.724 196.532 131.164C196.16 131.621 196.215 132.114 196.229 132.218L195.971 155.017C195.95 157.088 195.235 158.954 194.288 160.78C192.498 164.222 189.082 167.265 184.88 167.866C181.664 168.325 178.648 166.953 177.096 164.354C174.053 159.26 176.588 152.167 181.389 148.512C185.224 145.674 189.255 145.872 191.8 147.943L192.101 119.297C192.105 118.915 192.388 118.618 192.764 118.52L231.138 108.152C231.758 107.989 232.317 108.447 232.311 109.005L231.898 147.192C231.871 149.85 230.931 152.39 229.362 154.569C227.742 156.818 225.371 158.482 222.633 159.433C220.863 160.048 218.982 160.113 217.204 159.576C213.677 158.512 211.836 155.173 211.74 151.843C211.614 147.418 213.788 143.207 217.483 140.388C221.271 137.656 223.736 137.424 227.744 139.395L227.909 123.251C227.915 122.933 227.77 122.706 227.583 122.565C227.367 122.4 227.081 122.285 226.722 122.38L197.519 130.601L197.516 130.603Z"
        fill="#8E8E8E"
      />
    </motion.svg>

    <motion.svg
      className="wave"
      variants={waveGroupVariants}
      width="408"
      height="276"
      viewBox="0 0 408 276"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <motion.path
        variants={wavePathVariants}
        d="M310.528 184.753C309.249 184.026 308.834 182.402 309.599 181.155C317.239 168.719 321.383 154.467 321.554 139.864C321.791 123.919 317.301 108.312 308.653 94.8956C307.85 93.6503 308.257 91.9951 309.552 91.257L316.055 87.5472C317.276 86.8508 318.837 87.2294 319.59 88.4052C329.176 103.348 334.282 120.722 334.317 138.472C334.388 155.784 329.667 172.733 320.588 187.551C319.849 188.758 318.265 189.158 317.028 188.453L310.528 184.753Z"
      />
      <motion.path
        variants={wavePathVariants}
        d="M291.251 173.749L284.742 170.053C283.456 169.324 283.035 167.686 283.818 166.443C289.116 158.036 291.882 148.323 291.796 138.385C291.733 128.122 288.618 118.142 282.865 109.651C282.022 108.408 282.425 106.72 283.737 105.971L290.246 102.258C291.446 101.573 292.986 101.923 293.748 103.065C300.877 113.741 304.646 126.314 304.553 139.17C304.484 151.074 301.166 162.642 294.805 172.851C294.059 174.05 292.486 174.451 291.251 173.749Z"
      />
      <motion.path
        variants={wavePathVariants}
        d="M265.44 159.049L258.926 155.344C257.605 154.592 257.21 152.894 258.064 151.643C263.712 143.368 263.281 132.362 257.066 124.551C256.084 123.318 256.461 121.507 257.837 120.723L264.386 116.998C265.544 116.34 267.02 116.64 267.812 117.701C272.392 123.851 274.838 131.304 274.785 138.994C274.743 145.836 272.742 152.475 268.945 158.229C268.187 159.379 266.643 159.733 265.438 159.049H265.44Z"
      />
    </motion.svg>
  </motion.div>
)
